import type { IconData } from '@stacksjs/iconify-core'

export const cyborg2: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M41.666 40.129c-.211 2.534-2.209 4.398-4.747 4.547C34.13 44.839 29.892 45 24 45s-10.13-.16-12.919-.324c-2.538-.15-4.536-2.014-4.747-4.547C6.156 37.986 6 34.977 6 31s.156-6.985.334-9.129c.211-2.533 2.209-4.398 4.747-4.547C13.87 17.161 18.108 17 24 17s10.13.16 12.919.324c2.538.15 4.536 2.013 4.747 4.547c.178 2.144.334 5.152.334 9.129s-.156 6.986-.334 9.129M28 7a4 4 0 1 1-8 0a4 4 0 0 1 8 0m-4 4v6m-7 9v1m14-1v1\"/><path d=\"M30 36s-1.886 2-6 2s-6-2-6-2\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default cyborg2
